import React, { useEffect, useState } from 'react';
import Menu from '../components/menuComp';
import Header from '../components/headerComp';
import Footer from '../components/footerComp';
import ProductCard from '../components/productCard';
import { Container, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom'; 
import '../App.css';
import SearchBars from '../components/searchBarsComp';

const SearchPage = () => {
  const location = useLocation();
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Fetch items from your API or JSON file
    fetch('/items.json?v=2')
      .then(response => response.json())
      .then(data => {
        setItems(data);
        
        // Check if there's a search query in location.state
        const searchQuery = location.state?.query;
        if (searchQuery) {
          const results = data.filter(item => 
            Object.values(item).some(value => 
              value.toString().toLowerCase().includes(searchQuery.toLowerCase())
            )
          );
          setFilteredItems(results.length > 0 ? results : data); // Default to all items if no results
        }
      })
      .catch(error => console.error('Error fetching data:', error));
  }, [location.state]);

  const handleNoMatch = () => {
    setShowModal(true);
    setTimeout(() => {
      setShowModal(false);
    }, 2000);
  };

  const handleSearch = (query, type) => {
    if (type === 'clear') {
      setFilteredItems(items);
    } else if (type === 'all') {
      const filteredItems = items.filter(item =>
        Object.values(item).some(value =>
          value.toString().toLowerCase().includes(query.toLowerCase())
        )
      );
      if (filteredItems.length === 0) {
        handleNoMatch();
      } else {
        setFilteredItems(filteredItems);
      }
    }
  };

  const handleCloseModal = () => setShowModal(false);

  return (
    <div className="home-container">
      <Header />
      <Menu onSearch={handleSearch} /> {/* Pass handleSearch as onSearch */}
      <main className="flex-grow-1">
        <SearchBars onSearch={handleSearch} showModal={showModal} handleCloseModal={handleCloseModal} />
        <Container>
          {filteredItems.length > 0 ? (
            <Row>
              {filteredItems.map(item => (
                <ProductCard key={item.stockNumber} item={item} />
              ))}
            </Row>
          ) : (
            <p>No items found</p> 
          )}
        </Container>
      </main>
      <Footer />
    </div>
  );
};

export default SearchPage;
